/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_b24857f8"]'><div :class='["default-swipe-demo"]'><mpx-scroll-view><div :class='["default-swipe-example"]'><cube-swipe :list="(swipeData)" @item-click="onItemClick" @btn-click="onBtnClick"></cube-swipe></div></mpx-scroll-view><cube-action-sheet ref="__mpx_ref_deleteDefaultActionSheet__" title="确认要删除吗" :inputData="(deleteActionData)" @select='(e)=>__invoke(e, [["onDeleteSelect"]])'/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_b24857f8"}'>
.default-swipe-example
  background-color #fff
  border-radius 8px
  overflow hidden
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_b24857f8"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_b24857f8"}
  /** script content **/
  require("./default-swipe.mpx.js?isComponent&outputPath=components%2Fdefault-swipeb24857f8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./default-swipe.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdefault-swipeb24857f8%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_b24857f8"],
    ctorType: "component",
    outputPath: "components/default-swipeb24857f8/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-swipe':getComponent(require("../../../packages/mpx-cube-ui/src/components/swipe/index.mpx?isComponent&outputPath=components%2Findex1b0c1aa7%2Findex")),'cube-action-sheet':getComponent(require("../../../packages/mpx-cube-ui/src/components/action-sheet/index.mpx?isComponent&outputPath=components%2Findex51c8754f%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>